import { render, staticRenderFns } from "./ReporteProveedores.vue?vue&type=template&id=84f30098&"
import script from "./ReporteProveedores.vue?vue&type=script&lang=js&"
export * from "./ReporteProveedores.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports